/**
 * Tipos de mídia devolvidos pela API ('Vídeo' | 'Áudio' | 'PDF' | 'Imagem').
 * Comparação sempre normalizada em minúsculas, igual ao app.
 */
export const MEDIA_TYPE = {
    VIDEO: 'vídeo',
    AUDIO: 'áudio',
    PDF: 'pdf',
    IMAGE: 'imagem'
};

export const normalizeMediaType = type => (type || '').trim().toLowerCase();

/** Só abrimos/tocamos links http(s): bloqueia `javascript:`/`data:` vindos da API. */
export const isSafeMediaLink = link => /^https?:\/\//i.test(link || '');

/**
 * Vídeo e áudio tocam no player embutido; os demais tipos (PDF, Imagem)
 * são abertos numa nova aba, onde o próprio navegador os exibe.
 */
export const isPlayableMedia = media => {
    const type = normalizeMediaType(media.type);

    return type === MEDIA_TYPE.VIDEO || type === MEDIA_TYPE.AUDIO;
};

export const openInNewTab = url => {
    const newWindow = window.open(url, '_blank', 'noopener,noreferrer');

    if (newWindow) newWindow.opener = null;
};
